export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA'
export const RESET_FORM_DATA = 'RESET_FORM_DATA'
export const SET_FORM_STEP = 'SET_FORM_STEP'
export const RESET_FORM_STORE = 'RESET_FORM_STORE'
export const ON_ADDRESS_PICKED = 'ON_ADDRESS_PICKED'
export const ON_NEW_ACCOUNT_LOGIN_INITIATED = 'ON_NEW_ACCOUNT_LOGIN_INITIATED'
